module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-precomposed-58589dd5f9acde5c2bd02716c32b4cd1.png";